<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="card z-index-2"><div class=" card-header border">خروج</div>
                <div class="p-3 card-body">
                    <p class="py-4 pe-3 text-dark">در حال خروج ...</p></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapMutations } from "vuex";
import { mapActions } from "vuex/dist/vuex.cjs.js";

    export default {
        name: "Signout",
        data() {
            return {

            };
        },
        components: {
        },
        created() {

            this.resetCurrentUserInfo();
            this.emptyNotificationLists();
            localStorage.setItem('user_info', '');
            // localStorage.setItem('newReferralNotifications', []);
            // localStorage.setItem('myTicketsNotifications', []);
            localStorage.removeItem('user_info');
            localStorage.clear();

            setTimeout(() => this.$router.replace({ path: '/signin' }), 1000);

        },
        methods: {
            ...mapMutations(["resetCurrentUserInfo"]),
            ...mapActions(["emptyNotificationLists"])
       }
    };
</script>
